import(/* webpackMode: "eager" */ "/home/runner/work/marbles-stack/marbles-stack/apps/platform/src/app/global-error.tsx");
